





































































































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import MemberKey from "@/components/member-key";
import SupportKey from "@/components/support-key";
import _ from "lodash";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }
    const supportStore = inject(SupportKey);
    if (!supportStore) {
      throw new Error(`${SupportKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);
    const member = computed(() => memberStore.member);
    const inquiryTypeList = computed(() => supportStore.inquiryTypeList);
    const inquiryParams = computed(() => supportStore.inquiryParams);
    let selectedType = ref("");

    // 確認実行前からエラーメッセージが出るのを防ぐ用
    const validateActionFlag = ref<boolean>(false);

    const displayInquiryErrorFlag = computed(
      () => supportStore.displayInquiryErrorFlag
    );
    const displayInquiryError = computed(
      () => supportStore.displayInquiryError
    );

    const setSelectedInquiryTypeName = (e: any) => {
      supportStore.setSelectedInquiryTypeName(e);
    };

    const inputInquiryParamsInquiryType = (e: any) => {
      supportStore.inputInquiryParamsInquiryType(e);
      supportStore.validateInquiryParams();
    };
    const inputInquiryParamsMailAddress = (e: any) => {
      supportStore.inputInquiryParamsMailAddress(e);
      supportStore.validateInquiryParams();
    };
    const inputInquiryParamsPhoneNumber = (e: any) => {
      supportStore.inputInquiryParamsPhoneNumber(e);
      supportStore.validateInquiryParams();
    };
    const inputInquiryParamsContents = (e: any) => {
      supportStore.inputInquiryParamsContents(e);
      supportStore.validateInquiryParams();
    };

    const confirm = () => {
      validateActionFlag.value = true;
      supportStore.validateInquiryParams();
      if (!displayInquiryErrorFlag.value) {
        context.root.$router.push({ name: "MemberFaqInquiryConfirm" });
      }
    };

    onMounted(async () => {
      memberStore.setAuthorizationHeader(accessToken.value);
      supportStore.setAuthorizationHeader(accessToken.value);

      supportStore.getInquiryTypeList();
      await memberStore.getMember();
      if (!inquiryParams.value.contents) {
        supportStore.setInitialInquiryParams(member.value);
      } else {
        selectedType.value = inquiryParams.value.inquiry_type;
      }
    });

    return {
      member,
      inquiryParams,
      inquiryTypeList,
      selectedType,
      setSelectedInquiryTypeName,
      inputInquiryParamsInquiryType,
      inputInquiryParamsMailAddress,
      inputInquiryParamsPhoneNumber,
      inputInquiryParamsContents,
      validateActionFlag,
      displayInquiryErrorFlag,
      displayInquiryError,
      confirm
    };
  },
  components: {}
});
